import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "payments",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.PAYMENTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.PAYMENTS.PERMISSIONS,
    },
    component: () => import("@/modules/Payments/views/PaymentList.vue"),
  },
  {
    path: PATH.CREATE_PAYMENT,
    name: "createPayment",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CREATE_PAYMENT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.CREATE_PAYMENT.PERMISSIONS,
    },
    component: () => import("@/modules/Payments/views/CreatePayment.vue"),
  },
  {
    path: PATH.PAYMENT_DETAIL,
    name: "paymentDetail",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.PAYMENTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.PAYMENTS.PERMISSIONS,
    },
    component: () => import("@/modules/Payments/views/PaymentList.vue"),
  },
];

export default routes;
